import { T }         from 'defa-object';
import ControlModule from 'scripts/poppet/control-module';
import template      from './controlTemperatureAlertView.jst.html';
import { Vue }       from 'vue/defavue';

const temperatureSwitchOptions     = [
	{ value: 'ON', 	title: T.tc( 'HomeAlert', 'On' ), 	titleContext: 'HomeAlert' },
	{ value: 'OFF', title: T.tc('HomeAlert', 'Off' ),	titleContext: 'HomeAlert' }
];

export const ControlTemperatureAlertView = ControlModule.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	template : template,
	
	className: function () {
		return this._getClassName( 'control-home-alerts' );
	},
	
	onDomRefresh() {
		let self   = this;
		
		new Vue ({
			el: '#temp-slider',
			
			bb() {
				return {
					model: self.model,
				};
			},
			
			data() {
				return {
					temperatureSwitchValue: 'ON',
					temperatureSwitchOptions,
				}
			},
			methods : {
				save(newValue, attributeName) {
					let data = {};
					data[attributeName]= {
						highTemp: 'ON' === this.temperatureSwitchValue,
						lowTemp : 'ON' === this.temperatureSwitchValue,
					};
					self.save( data )
				},
			},
			
			watch: {
				'model.alarmMask': function (newAttribute){
					this.temperatureSwitchValue = newAttribute.highTemp &&  newAttribute.lowTemp ? 'ON' : 'OFF';
				}
			},
			
			created() {
				this.temperatureSwitchValue = this.model.alarmMask && this.model.alarmMask.highTemp && this.model.alarmMask.lowTemp  ? 'ON' : 'OFF';
			}
		});
	},
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
	save: function (attributes) {
		this.model.set('isValidData', false);
		try {
			this.model.save( attributes, {
				isSaving: true,
				patch: true,
				success: function () {
					console.log( Object.keys(attributes)[0] +' was succesfully saved!' );
				},
				error  : function (model, response) {
					console.error( Object.keys(attributes)[0] + ' failed saving with error: ' + response.responseJSON.message );
				}
			} );
		} catch ( err ) {
			alert( 'Failed syncing' );
			console.error( err );
			setTimeout( () => this.idle(), 1000 );
		}
	},
});

export default  ControlTemperatureAlertView;
